import React, { FunctionComponent, useEffect } from 'react';
import { Text } from "@sitecore-jss/sitecore-jss-react";
import { FindADealerModel } from "./fields.model";

const LocatorForm: FunctionComponent<{ model: FindADealerModel }> = ({ model }) => {
    useEffect(() => {
        if (typeof window !== 'undefined' && 'customElements' in window) {
          import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
        }
      }, []);
    return (
        <>
            <form className="find-a-dealer__form" action={model.searchUrl}>
                <div className="find-a-dealer__input-wrapper find-a-dealer__input-wrapper--address">
                    <pfe-icon icon="dcx-search" class="find-a-dealer__input-icon" />
                    <input name={'address'} placeholder={model.inputPlaceholderText} className="find-a-dealer__input" />
                </div>
                <pfe-cta pfe-priority="primary" class="find-a-dealer__cta find-a-dealer__cta--submit">
                    <button type="submit">{model.searchButtonText}</button>
                </pfe-cta>
            </form>
            <pfe-cta pfe-priority="primary" class="find-a-dealer__cta find-a-dealer__cta--locate-me">
                <button type="button"><Text field={model.locateMeButton} /></button>
            </pfe-cta>
        </>
    )
}

export default LocatorForm;
